<template>
  <div>
    <div class="section-hero">
      <video ref="heroVid" autoplay loop muted playsinline preload="metadata" poster="/frontend/assets/images/og-image.jpg">
        <source src="/frontend/assets/videos/video.mp4" type="video/mp4" />
      </video>

      <div class="container">
        <div class="paragraph--normal wide text-uppercase text-color-quinary">
          <span class="notranslate" translate="no">SELECTED</span> CARS
        </div>
        <div class="heading--1 fw-light text-uppercase text-color-quinary my-4">
          WITHOUT COMPROMISE
        </div>
        <div
          class="paragraph--normal wide text-uppercase text-color-quinary d-lg-block d-none"
        >
          LUXURY CAR DEALERSHIP
        </div>
        <div
          class="d-flex gap-3 justify-content-start justify-content-lg-center w-100 mt-lg-5"
        >
          <router-link
            to="/inventory"
            class="btn btn--normal btn--primary text-uppercase px-lg-5"
            >CARS FOR SALE</router-link
          >
          <router-link
            to="/about"
            class="btn btn--normal btn--primary text-uppercase px-lg-5"
            >ABOUT US</router-link
          >
        </div>
      </div>
    </div>

    <div class="section-normal bg-color-primary">
      <div class="container margin-bottom-9-lg margin-bottom-5">
        <div class="border-bottom-quinary padding-bottom-5-lg padding-bottom-3">
          <div class="row">
            <div class="col-lg-4 mb-lg-0 mb-4">
              <h2 class="heading--1 text-color-quinary text-uppercase mb-0">
                Our<br />
                Story
              </h2>
            </div>
            <div class="col-lg-6 offset-lg-2">
              <div class="paragraph--xlarge text-color-quinary">
                What began as a passion for extraordinary automobiles has
                evolved into a legacy of excellence. Over the years, we have
                grown into a trusted name in luxury automotive sales, known for
                meeting even the most refined expectations. Yet, at the heart of
                everything we do remains an unwavering love for automotive
                perfection — a force that continues to drive us forward.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <MasonryGallery />
      </div>
    </div>

    <div class="section-mini home-stats">
      <div class="container">
        <div class="row text-center">
          <div class="col-md-3 col-6 mb-md-0 mb-5">
            <div class="heading--0 text-uppercase mb-2 notranslate" translate="no" style="color: #111;">20+</div>
            <div class="paragraph--xlarge wide text-uppercase" style="color: #888;">Years of<br>Experience</div>
          </div>
          <div class="col-md-3 col-6 mb-md-0 mb-5">
            <div class="heading--0 text-uppercase mb-2 notranslate" translate="no" style="color: #111;">1000+</div>
            <div class="paragraph--xlarge wide text-uppercase" style="color: #888;">Cars<br>Sold</div>
          </div>
          <div class="col-md-3 col-6">
            <div class="heading--0 text-uppercase mb-2 notranslate" translate="no" style="color: #111;">16</div>
            <div class="paragraph--xlarge wide text-uppercase" style="color: #888;">Countries<br>Covered</div>
          </div>
          <div class="col-md-3 col-6">
            <div class="heading--0 text-uppercase mb-2 notranslate" translate="no" style="color: #111;">92</div>
            <div class="paragraph--xlarge wide text-uppercase" style="color: #888;">Partner<br>Dealers</div>
          </div>
        </div>
      </div>
    </div>

    <FeaturedCars :show-filter="true" />

    <AppMap />
    <AppMarquee />
  </div>
</template>

<script>
import axios from 'axios';
import AppMap from '../components/AppMap.vue';
import AppMarquee from '../components/AppMarquee.vue';
import MasonryGallery from '../components/MasonryGallery.vue';
import FeaturedCars from '../components/FeaturedCars.vue';
export default {
  components: {
    AppMap,
    AppMarquee,
    MasonryGallery,
    FeaturedCars
  },
  mounted() {
    this.loadSettings();
    import('../seo.js').then(({ setPageSeo }) => setPageSeo({
      title: 'Selected Cars | Buy & Export Luxury Cars from Europe | Worldwide Delivery',
      description: 'Export premium European cars worldwide. Buy BMW, Mercedes, Porsche, Audi, Lamborghini, Ferrari direct from Europe with door-to-door delivery to Middle East, Asia, Africa & beyond. 1000+ cars exported to 16 countries. Trusted European car exporter since establishment.',
      keywords: 'buy car from europe, export car from europe, european car exporter, import car from europe, luxury car export worldwide, car broker europe, BMW export europe, Mercedes export, Porsche buy europe, Audi export, Lamborghini from europe, Ferrari europe delivery, car dealer europe worldwide shipping, european car dealer international, buy european car online, car import to UAE, car import to Dubai, car export to middle east, car export to africa, car export to asia, european luxury car broker, selected cars',
      canonical: 'https://selected.sk/',
      breadcrumbs: [
        { name: 'Home', url: '/' }
      ],
      schema: {
        "@context": "https://schema.org",
        "@type": "VideoObject",
        "name": "Selected Cars — Luxury Vehicle Showroom",
        "description": "Selected Cars showroom — premium European luxury vehicles available for export worldwide.",
        "thumbnailUrl": "https://selected.sk/frontend/assets/images/og-image.jpg",
        "contentUrl": "https://selected.sk/frontend/assets/videos/video.mp4",
        "uploadDate": "2025-04-30T00:00:00+00:00",
        "duration": "PT30S",
        "isFamilyFriendly": true
      }
    }));
  },
  methods: {
    async loadSettings() {
      try {
        const response = await axios.get('/api/settings/homepage');
        if (response.data && response.data.homepage_video) {
          const newSrc = response.data.homepage_video;
          const vid = this.$refs.heroVid;
          // Only swap if admin uploaded a different video
          if (vid && newSrc !== '/frontend/assets/videos/video.mp4') {
            vid.querySelector('source').src = newSrc;
            vid.load();
            vid.play().catch(() => {});
          }
        }
      } catch (e) {
        // Keep default video on error
      }
    },
  },
};
</script>

<style scoped>
.home-stats {
  background: #fff;
}
</style>
